module.exports = __webpack_public_path__ + "static/media/background.99366187.png";